import React from "react";
import { fmtTimeShort } from "./rowUtils";

/**
 * Floating badge that follows the cursor during drag/resize, showing the
 * snap-target time (or +/- delta minutes for resize).
 */
export default function DragBadge({ mouseY, deltaMin, toTime, kind, anchorTitle }) {
  const sign = deltaMin > 0 ? "+" : "";
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-[80] bg-bg-surface border border-amber px-3 py-1.5 shadow-[0_8px_24px_rgba(0,0,0,0.6)] pointer-events-none animate-slide-up"
      style={{ top: Math.max(80, mouseY - 50) }}
      data-testid="drag-badge"
    >
      <div className="mono text-2xs uppercase tracking-widest text-ink-mute">
        {kind === "resize" ? "RESIZE" : kind === "snap" ? "DROP AFTER" : "MOVE"}
      </div>
      {kind === "snap" && anchorTitle && (
        <div className="text-2xs text-ink truncate max-w-[280px] mt-0.5">{anchorTitle}</div>
      )}
      <div className="mono text-sm text-amber tabular-nums mt-0.5">
        {kind === "snap" ? "starts " : ""}
        {fmtTimeShort(toTime)}
        {kind !== "snap" && (
          <>
            {" "}
            <span className="text-ink-mute">
              ({sign}
              {deltaMin}m)
            </span>
          </>
        )}
      </div>
    </div>
  );
}
